var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{
    'button--secondary': _vm.secondary,
    'button--big': _vm.big,
    'button--wide': _vm.wide,
    'button--small': _vm.small,
    'button--finished': _vm.doneLoading,
    'button--loading': _vm.loading,
  },attrs:{"type":_vm.buttonType,"disabled":_vm.loading},on:{"click":_vm.event}},[((_vm.doneLoading && !_vm.loading) || (_vm.doneLoading && !_vm.async))?_c('IconCheckmark',{staticClass:"icon icon--green layout--margin-right-xxs"}):_vm._e(),(_vm.loading)?_c('spring-spinner',{staticClass:"layout--inline-block layout--margin-right-sm",attrs:{"animation-duration":1500,"size":21,"color":'#b6bbff',"transition":"fade","mode":"out-in","duration":1000,"enter-active-class":"enter-active"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.currentLabel)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }